import React from 'react';

import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import type { GlyphProps } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';

export const QuickSummaryIcon = (props: GlyphProps) => (
	<AtlassianIntelligenceIcon color={token('color.icon')} {...props} />
);
